var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qr-code-generator"},[_c('canvas',{ref:"qrCanvas"}),_vm._v(" "),_c('woot-button',{attrs:{"title":_vm.$t('INTEGRATION_SETTINGS.MOBILE_APP.REFRESH'),"variant":"clear","color-scheme":"secondary","icon":"ion-android-refresh"},on:{"click":_vm.generateQRCode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }